/**
 * Format JWT expiry instant for UI (local clock + timezone).
 * Uses explicit fields so dates are not ambiguous (unlike default toLocaleString() dd/mm vs mm/dd).
 */
export function formatJwtExpiryForDisplay(expiresAtMs) {
  const ms = Number(expiresAtMs);
  if (!Number.isFinite(ms)) return '';
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return d.toLocaleString(undefined, {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZoneName: 'short'
    });
  } catch {
    return d.toISOString();
  }
}
